import React from "react";
import { compose, graphql } from "react-apollo";
import PlaceholderImg from "assets/img/operator-placeholder.jpg";
import Toggle from "react-toggle";
import Spinner from "react-spinkit";
import "react-toggle/style.css";
import { useAuthorizedOperator } from "contexts/AuthorizedOperatorContext";
import { withAuthentication } from "utils/withAuthentication";
import {
  Container,
  OperatorCard,
  Title,
  Info,
  Operator,
  Photo,
  Name,
  SpinnerContainer,
} from "./authorizedOperatorComponents";
import {
  REQUEST_OPERATOR_ACCESS_MUTATION,
  REMOVE_OPERATOR_ACCESS_MUTATION
} from "./authorizedOperatorQueries";

const AuthorizedOperator = ({
  currentUser,
  requestOperatorAccess,
  removeOperatorAccess,
}) => {
  const { operator, loading, refetch } = useAuthorizedOperator();

  if (loading) {
    return (
      <SpinnerContainer>
        <Spinner name="line-spin-fade-loader" color="green" fadeIn="none" />
      </SpinnerContainer>
    );
  }

  const user = currentUser;

  return (
    <Container>
      <OperatorCard className="operator-card">
        <Title>Operador Autorizado</Title>
        <Info className="operator-info">
          <Operator className="operator-img-wrapper">
            <Photo src={PlaceholderImg} />
            {operator && <Name>{operator.name}</Name>}
          </Operator>
          <Toggle
            disabled={operator && operator.id !== user.id}
            icons={{ unchecked: null }}
            checked={!!operator}
            onChange={async () => {
              if (operator) {
                await removeOperatorAccess();
              } else {
                await requestOperatorAccess();
              }
              refetch();
            }}
          />
        </Info>
      </OperatorCard>
    </Container>
  );
};

export default compose(
  withAuthentication,
  graphql(REQUEST_OPERATOR_ACCESS_MUTATION, { name: "requestOperatorAccess", }),
  graphql(REMOVE_OPERATOR_ACCESS_MUTATION, { name: "removeOperatorAccess", }),
)(AuthorizedOperator);
